export default __webpack_public_path__ + "static/media/unknown150.1b9fa301.jpg";